import React from 'react';
import TablePagination from './TablePagination';
import { ROWS_PER_PAGE_OPTIONS } from '../constants/pagination';
import './TablePagination.css';

/**
 * Tablo altı footer: toplam kayıt, opsiyonel satır seçici, standart pagination
 */
const TableListFooter = ({
  totalRecords = 0,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  loading = false,
  rowsPerPage,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
  onRowsPerPageChange,
  variant = 'default',
  className = '',
  showTotal = true,
  embedded = false,
}) => {
  const compact = variant === 'compact';
  const footerClass = [
    'table-footer',
    compact ? 'table-list-footer--compact' : '',
    embedded ? 'table-list-footer--embedded' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={footerClass}>
      {showTotal && (
        <div className="records-count">Toplam {totalRecords} kayıt</div>
      )}
      {rowsPerPage != null && onRowsPerPageChange && (
        <div className="rows-per-page">
          <span>Satır</span>
          <select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            className="rows-select"
            disabled={loading}
            aria-label="Sayfa başına satır"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="pagination-controls">
        <TablePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default TableListFooter;
